import { Shark, SmartModel, Utils } from "shark-mvc";
import moment from "moment";
import provinceList from "../data/province-list";
import Person from "./Person";

//NextBigThing: Cambiare nome da Client a Contact
class Client extends SmartModel {
	static STATUS_CLIENT = 1;
	static STATUS_CONTACT_FROM_SIS = 2;
	static STATUS_LEAD = 3;
	static STATUS_REPORT_FROM_LEAD = 4;
	static STATUS_PROSPECT = 5;
	static STATUS_CLIENT_FROM_LEAD = 6;
	static STATUS_CLIENT_FROM_PROSPECT = 7;
	static STATUS_CLIENT_ARCHIVED = 8;
	static STATUS_DELETE_REQUESTED = 10;
	static STATUS_CLIENT_FROM_SIS_CONTACT = 11;

	leadAttachmentGuidList = [];

	__leadAttachmentList = [];
	__peopleCount = 0;

	constructor(data) {
		super();

		this.activityStatus = -1; // 0: Non impostato, 1: In attesa, 4: Compilato report, 9: Non interessato
		this.address = "";
		this.agentAssignmentDate = "0000-00-00 00:00:00";
		this.association = "";
		this.city = "";
		this.code = "";
		this.contactPerson = "";
		this.contactRole = "";
		this.contactSource = "0";
		this.country = "";
		this.createdAt = "0000-00-00 00:00:00";
		this.createdByGuid = "";
		this.email = "";
		this.enabled = false;
		this.extraData = {
			activityStatusId: 0, //1: in attesa, 4: compilato report, 9: non interessato
			activityStatus: "",
			businessDescription: "",
			colorNotes: "",
			contactSourceDetailId: 0,
			isIndividual: false,
			leadIncomingMessage: "",
			leadInterestSector: "",
			leadInterestSolutions: [],
			leadIntermediaryGuid: "",
			leadSentDocumentation: false,
			leadIsPremium: false,
			leadIsTender: false,
			leadNotInterestedReason: "",
			leadRequestedArea: "",
			leadRequestDate: "0000-00-00 00:00:00",
			leadRequestSourcePage: "",
			leadRequestTrafficType: "",
			line: "",
			paymentNotes: "",
			previousStatus: 0,
			qualifications: "",
			roles: {
				customer: false,
				designer: false,
				endUser: false,
			},
			sourceFair: "",
		};
		this.guid = "";
		this.hasVisit = false;
		this.latestFollowUp = "";
		this.name = "";
		this.newFollowUpCount = 0;
		this.notes = "";
		this.people = [];
		this.phone = "";
		this.pictureURL = "";
		this.preferences = {};//Dave: Rimosso temporanemanete per dati temporanei nel DB di produzione
		this.profession = "";
		this.province = "";
		this.referenceAgentsGuids = [];
		this.referenceLineId = 0;
		this.region = "";
		this.sector = "";
		this.starred = false;
		this.status = 1; //[1: Attivo, 2: Inserito da SIS o simile, 3: Lead, 4: Lead Diventato report, 5: Nato come report (Prospect), 6: Lead diventato Cliente, 7: Prospect diventato cliente, 8: Archiviato, 9: Eliminato, 10: Eliminazione richiesta, 11: Contatto SIS diventato Cliente]
		this.updatedAt = "0000-00-00 00:00:00";
		this.updatedByGuid = "";
		this.zip = "";
		
		//Dave: Ok, bisogna gestire questa cosa dei dati "extra" che sono presenti solo in qualche caso (in questo caso su esportazione Lead). Magari estendendo modelli...
		this.quotationRefusedExtraData = {};

		this.__agentAssignmentDate = "";
		this.__agentAssignmentDateLabel = "";
		this.__agentAssignmentStatus = "";
		this.__agentFullName = "";
		this.__contactSourceLabel = "";
		this.__deleteCanBeRequested = true;
		this.__displayIndex = 0;
		this.__followUpList = [];
		this.__formattedNotes = "";
		this.__index = 0;
		this.__isValid = false;
		this.__lastValidationErrors = [];
		this.__latestFollowUpHtml = "";
		this.__leadIntermediaryFullName = "";
		this.__listNameLabel = "";
		this.__prospectAssignedAgentGuid = "";
		this.__prospectAssignedAgentName = "";
		this.__hasAppointment = false;
		this.__hasFollowUp = false;
		this.__hasNewFollowUp = false;
		this.__hasPendingCall = false;
		this.__hasPendingEMail = false;
		this.__needsAssignment = false;
		this.__nextAppointment = {};
		this.__nextCallAppointment = {};
		this.__nextEMailAppointment = {};
		this.__referenceLineLabel = "";
		this.__render = true;
		this.__reportData = {};
		this.__showSourceFair = false;
		this.__statusCSSClass = "";
		this.__typeCSSClass = "";

		if (data) {
			this.import(data);
		}
	}

	addAttachments (attachmentList) {
		const newAttachmentGuidList = attachmentList.map(item => item.guid);

		this.set({
			leadAttachmentGuidList: [...this.leadAttachmentGuidList, ...newAttachmentGuidList], // Dave: questo dovrebbe sempre essere estratto dall'altro... ?
			__leadAttachmentList: [...this.__leadAttachmentList, ...attachmentList],
		});

		return attachmentList.length > 0;
	}

	addFollowUp (followUp) {
		this.__followUpList.push(followUp);
		this.__followUpList.forEach((item, index) => item.__index = index);

		this.latestFollowUp = followUp.body;
		this.__latestFollowUpHtml = this.latestFollowUp.replace(/\n/g, "<br>");
	}

	addPerson (person) {
		this.people.push(person);
		this.reindexPeople();
		this.emit("peopleChanged");
	}

	deleteAttachment (guid) {
		if (this.leadAttachmentGuidList.includes(guid)) {
			this.set({
				leadAttachmentGuidList: this.leadAttachmentGuidList.filter(item => item !== guid), // Dave: questo dovrebbe sempre essere estratto dall'altro... ?
				__leadAttachmentList: this.__leadAttachmentList.filter(item => item.guid !== guid),
			});

			return true;
		}
		return false;
	}

	export() {
		var exportData = this.__export();

		//DAVE TO DO Dovrei stringifiare le cose che lo necessitano
		exportData.agentAssignmentDate = moment.utc(this.agentAssignmentDate).format("YYYY-MM-DD HH:mm:ss");
		exportData.enabled = this.enabled ? 1 : 0;
		exportData.extraData.leadRequestDate = moment.utc(this.extraData.leadRequestDate).format("YYYY-MM-DD HH:mm:ss");
		exportData.extraData = JSON.stringify(this.extraData);
		exportData.leadAttachmentGuidList = this.exportArrayField("leadAttachmentGuidList");
		exportData.people = JSON.stringify(this.people.map(item => item.export()));
		exportData.preferences = JSON.stringify(this.preferences);//Dave: Rimosso temporanemanete per dati temporanei nel DB di produzione
		exportData.referenceAgentsGuids = JSON.stringify(this.referenceAgentsGuids);

		return exportData;
	}

	import (data, options) {
		//Dave.Warn: Non dovrei modificare i dati che arrivano
		//Ma ci sono troppi dati brutti nel sistema.
		try {
			if (data.referenceAgentsGuids && data.referenceAgentsGuids !== "" && typeof data.referenceAgentsGuids === "string" && data.referenceAgentsGuids.substr(0, 1) === "[") {
				data.referenceAgentsGuids = Utils.parseJSON(data.referenceAgentsGuids, "array");
			}
			else if (!Array.isArray(data.referenceAgentsGuids)) {
				data.referenceAgentsGuids = [];
			}
		}
		catch (e) {
			console.error(e);
		}

		this.__import(data, options);

		//Dave: Rimosso temporanemanete per dati temporanei nel DB di produzione
		if (data.preferences && data.preferences !== "" && typeof data.preferences === "string" && data.preferences.substr(0, 1) === "{") {
			// this.preferences = Utils.parseJSON(data.preferences, "object");
		}
		else {
			this.preferences = {};
		}

		//Dave: questo è una schifezza
		// if (!this.extraData.activityStatus) {
		//	 this.set("extraData.activityStatusId", 1);
		// }
		this.hasVisit = parseInt(data.hasVisit) === 1;
		if (this.name !== "") {
			this.__listNameLabel = this.name;
		}
		else {
			this.__listNameLabel = this.contactPerson + (this.extraData.qualifications.trim() !== "" ? " <small>(" + this.extraData.qualifications + ")</small>" : " <small>(" + this.profession + ")</small>");
		}
	
		this.importNumberField("activityStatus", data.activityStatus);
	
		if (this.importDateField("agentAssignmentDate", data.agentAssignmentDate)) {
			this.__agentAssignmentDate = this.agentAssignmentDate.format(Shark.get("dtIsoDate"));
			this.__agentAssignmentDateLabel = this.agentAssignmentDate.format(Shark.get("dateHumanFormat"));
		}

		if (this.importDateField("createdAt", data.createdAt)) {
			this.__createdAt = this.createdAt.format(Shark.get("dtIsoDate"));
			this.__createdAtLabel = this.createdAt.format(Shark.get("dateHumanFormat"));
		}

		if (this.importDateField("extraData.leadRequestDate", this.extraData.leadRequestDate)) {
			this.__leadRequestDate = this.extraData.leadRequestDate.format(Shark.get("dtIsoDate"));
			this.__leadRequestDateLabel = this.extraData.leadRequestDate.format(Shark.get("dateHumanFormat"));
		}
		else {
			this.__leadRequestDateLabel = this.__createdAtLabel;
		}

		this.importNumberField("status", data.status);

		if (this.importDateField("updatedAt", data.updatedAt)) {
			this.__updatedAt = this.updatedAt.format(Shark.get("dtIsoDate"));
			this.__updatedAtLabel = this.updatedAt.format(Shark.get("dateTimeHumanFormat"));
		}

		const elapsedFromAssignment = Math.ceil(moment().diff(this.agentAssignmentDate, "h") / 24);

		//Dave: Tutto questo dovrebe essere combinato e gestito con activityStatus
		if (isNaN(elapsedFromAssignment)) {
			this.__agentAssignmentStatus = "";
		}
		else {
			if (this.status === 4 || this.extraData.activityStatusId === 9) {
				this.__agentAssignmentStatus = "assignment-yesterday";
				if (this.extraData.activityStatusId === 9) {
					this.__statusCSSClass = "lead-status-not-interested";
					this.extraData.activityStatus = "Non interessato";
				}
				else if (this.status === 4) {
					this.__statusCSSClass = "lead-status-report-compiled";
				}
			}
			else if (this.status === 6) {
				this.__statusCSSClass = "lead-status-become-customer";
			}
			else if (this.status === 7) {
				this.__statusCSSClass = "lead-status-become-customer";
			}
			else {
				switch (elapsedFromAssignment) {
					case 0:
					case 1:
					case 2:
					case 3:
						this.__agentAssignmentStatus = "assignment-yesterday";
						this.__statusCSSClass = "lead-status-waiting";
						break;
					default:
						this.__agentAssignmentStatus = "assignment-expired";
						this.__statusCSSClass = "lead-status-not-interested";
						break;
				}
			}
		}

		this.__formattedNotes = this.notes.replace(/\n/g, "<br>");
		if (typeof data.latestFollowUp === "string") {
			this.latestFollowUp = data.latestFollowUp;
			this.__latestFollowUpHtml = this.latestFollowUp.replace(/\n/g, "<br>");
			this.__hasFollowUp = this.latestFollowUp !== "";
		}

		const [contactSourceMap, contactSourceDetailMap] = Shark.get(["contactSourceMap", "contactSourceDetailMap"]);
		this.__contactSourceLabel = contactSourceMap[this.contactSource];
		this.__contactSourceDetailLabel = contactSourceDetailMap[this.extraData.contactSourceDetailId];
		this.__showSourceFair = parseInt(this.contactSource) === 2;

		this.importBooleanField("enabled", data.enabled);
		this.importNumberField("newFollowUpCount", data.newFollowUpCount);
		this.__hasNewFollowUp = this.newFollowUpCount > 0;
		this.importNumberField("referenceLineId", data.referenceLineId);
		this.importBooleanField("starred", data.starred);

		switch (this.status) {
			case Client.STATUS_CLIENT: //1
				this.__statusLabel = "Cliente";
				this.__typeCSSClass = "client-type-client";
				break;
			case Client.STATUS_CONTACT_FROM_SIS: //2
				this.__statusLabel = "Contatto da Scheda Informativa";
				break;
			case Client.STATUS_LEAD://3
				this.__statusLabel = "Lead";
				this.__typeCSSClass = "client-type-lead";
				this.__deleteCanBeRequested = false;
	
				if (this.activityStatus === 9 || this.extraData.activityStatusId === 9) {
					this.__statusCSSClass = "lead-status-not-interested";
				}
				else {
					this.__statusCSSClass = "lead-status-waiting";
					this.__needsAssignment = true;
				}
				break;
			case Client.STATUS_REPORT_FROM_LEAD://4
				this.__statusCSSClass = "lead-status-report-compiled";
				this.__statusLabel = "Lead";
				this.__typeCSSClass = "client-type-lead";
				this.__deleteCanBeRequested = false;
				break;
			case Client.STATUS_PROSPECT://5
				this.__statusLabel = "Prospect";
				this.__typeCSSClass = "client-type-visit";
				break;
			case Client.STATUS_CLIENT_FROM_LEAD://6
				//DAve.Warn: Occhio che ogni volta che cambio queste cose, dovrei salvarle sul DB.. o meglio, non deve essere cambiato durante il parse.. :|
				this.set("extraData.activityStatusId", 6);
				this.__statusLabel = "Cliente da Lead";
				this.__typeCSSClass = "client-type-client";
				this.__deleteCanBeRequested = false;
				break;
			case Client.STATUS_CLIENT_FROM_PROSPECT://7
				this.set("extraData.activityStatusId", 7);
				this.__statusLabel = "Cliente da Prospect";
				this.__typeCSSClass = "client-type-client";
				break;
			case Client.STATUS_DELETE_REQUESTED: //10
				this.__statusLabel = `<span class="text-danger">(richiesta eliminazione)</span>`;
				this.__status__delete_requested = true;
				// this.__typeCSSClass = "client-type-client";
				break;
			case Client.STATUS_CLIENT_FROM_SIS_CONTACT://11
				this.__statusLabel = "Cliente da Contatto Scheda Informativa";
				this.__typeCSSClass = "client-type-sis-contact";
				break;
			default:
				break;
		}

		// if (this.status === 3 && this.referenceAgentsGuids.length > 0) {
		if (this.referenceAgentsGuids.length > 0) {
			this.__prospectAssignedAgentGuid = this.referenceAgentsGuids[0];
			const agentList = Shark.get("agentList");
			
			if (this.__prospectAssignedAgentGuid !== "" && agentList) {
				const assignedAgent = Utils.safp(agentList, "guid", this.__prospectAssignedAgentGuid);
				if (assignedAgent) {
					this.__agentFullName = assignedAgent.__fullName;
					this.agentGuid = assignedAgent.guid;
					this.__prospectAssignedAgentName = assignedAgent.__fullName;
				}
			}
		}

		this.__reportData.province = this.province;
		
		this.__rolesLabel = "";
		if (this.extraData.roles.customer) {
			this.__rolesLabel += ", Committente";
		}
		if (this.extraData.roles.designer) {
			this.__rolesLabel += ", Progettista";
		}
		if (this.extraData.roles.endUser) {
			this.__rolesLabel += ", Utilizzatore finale";
		}

		if (this.__rolesLabel !== "") {
			this.__rolesLabel = this.__rolesLabel.substr(2);
		}
		else {
			this.__rolesLabel = "<small>(ruolo non impostato)</small>";
		}

		this.parseActivityStatus();
		this.parseAttachment();
		this.parseIntermediary();
		this.parseLeadInformations();
		this.parsePeople();
		this.parseReferenceLine();

		this.parseNotInterested();
	}

	matchAttachments (attachmentList, replaceAll) {
		let count = 0;

		if (replaceAll) {
			this.__leadAttachmentList = [];
		}

		attachmentList.forEach(item => {
			if (this.leadAttachmentGuidList.includes(item.guid)) {
				this.__leadAttachmentList.push(item);
				count++;
			}
		});

		return count > 0;
	}

	parseAttachment () {
		this.__leadAttachmentList = this.leadAttachmentGuidList.map(item => new Document({guid: item}));
	}


	isValid (checkType = "") {
		this.validate(checkType);

		return this.__isValid;
	}

	onCityChanged(data) {
		console.log(data);
		const city = provinceList.find(item => item.city.toLowerCase() === this.city.toLowerCase());

		if (city) {
			this.set("country", "Italia");
			this.set("province", city.plate);
			this.set("region", city.region);
		}
	}
	
	onDataChanged(data) {
		switch (data.property) {
			case "extraData.activityStatusId":
				this.parseActivityStatus();
				break;
			case "pictureURL":
				this.__hasThumbnailURL = this.pictureURL !== "";
				break;
			case "province": {
				this[data.property] = data.newValue.toUpperCase();
				const regionProperty = data.property.replace("province", "region");
				const regionField = document.querySelector(`input[data-sh-prop="${regionProperty}"]`);
				const region = provinceList.filter(item => item.plate === this[data.property]);

				if (region.length === 1) {
					this[regionProperty] = region[0].region;

					if (regionField) {
						regionField.value = this[regionProperty];
					}
				}
				break;
			}
			case "__agentAssignmentDate":
				this.agentAssignmentDate = moment(this.__agentAssignmentDate);
				this.__agentAssignmentDateLabel = this.agentAssignmentDate.format(Shark.get("dateHumanFormat"));
				break;
			case "__followUpList":
				this.__hasFollowUp = this.__followUpList.length > 0;
				break;
			case "__prospectAssignedAgentGuid": {
				this.referenceAgentsGuids = [this.__prospectAssignedAgentGuid];
				const agentList = Shark.get("agentList");
			
				if (this.__prospectAssignedAgentGuid !== "" && agentList) {
					const assignedAgent = Utils.safp(agentList, "guid", this.__prospectAssignedAgentGuid);
					if (assignedAgent) {
						this.__agentFullName = assignedAgent.__fullName;
						this.agentGuid = assignedAgent.guid;
						this.__prospectAssignedAgentName = assignedAgent.__fullName;
					}
				}
				break;
			}
		}
	}

	onExtraData_isIndividualChanged () {
		const nameField = document.querySelector("#nameField");

		if (nameField) {
			nameField.disabled = this.extraData.isIndividual;
			if (this.extraData.isIndividual) {
				this.set("name", this.contactPerson);
			}
		}
	}

	onContactPersonChanged () {
		if (this.extraData.isIndividual) {
			this.set("name", this.contactPerson);
		}
	}

	onReferenceLineIdChanged () {
		this.extraData.leadInterestSolutions = [];

		for (let i = 1; i <= 7; i++) {
			const chk = document.querySelector(`#leadInterestSolutions${i}Field`);

			if (chk) {
				chk.checked = false;
			}
		}
		
		this.parseReferenceLine();
	}

	onExtraData_leadInterestSolutionsChanged () {
		//Non mi fa impazzire, ma devo conservare numeri quando dal checkbox arrivano stringhe...
		this.extraData.leadInterestSolutions = this.extraData.leadInterestSolutions.map(item => parseInt(item));
		this.parseReferenceLine();
	}

	parseActivityStatus () {
		//Dave: Qui c'è un casino da sistemare, queste classi vengono impostate in 32 posti diversi
		if (this.activityStatus !== undefined && this.activityStatus > 0) {
			const clientActivityStatusMap = Shark.get("clientActivityStatusMap");
			this.__activityStatusLabel = clientActivityStatusMap[this.activityStatus];

			this.__activityStatus_notInterested = this.activityStatus === 9;

			switch (this.activityStatus) {
				case 4:
					this.__statusCSSClass = "lead-status-report-compiled";
					this.__needsAssignment = false;
					break;
				case 5:
				case 8:
				case 11:
					this.__statusCSSClass = "lead-status-sis-created";
					this.__needsAssignment = false;
					break;
				case 7:
				case 9:
					this.__statusCSSClass = "lead-status-not-interested";
					this.__needsAssignment = false;
					break;
			}

		}
		else {
			switch (this.extraData.activityStatusId) {
				case 1:
					this.extraData.activityStatus = "In attesa";
					break;
				case 4:
					this.extraData.activityStatus = "Compilato report";
					this.__statusCSSClass = "lead-status-report-compiled";
					break;
				case 6:
					this.extraData.activityStatus = "Diventato cliente";
					this.__statusCSSClass = "lead-status-become-customer";
					break;
				case 9:
					this.extraData.activityStatus = "Non interessato";
					this.__statusCSSClass = "status-danger";
					break;
			}
		}
	}

	parseIntermediary () {
		const intermediaryList = Shark.get("intermediaryList");
			
		if (this.extraData.leadIntermediaryGuid !== "" && intermediaryList) {
			const assignedAgent = Utils.safp(intermediaryList, "guid", this.extraData.leadIntermediaryGuid);

			if (assignedAgent) {
				this.__leadIntermediaryFullName = assignedAgent.__fullName;
			}
		}
	}

	parseLeadInformations () {
		this.__contactSourceExtraInfoLabel = "";

		if (this.extraData.leadRequestSourcePage) {
			this.__contactSourceExtraInfoLabel += "Origine: " + this.extraData.leadRequestSourcePage.replace(/"/g, "'");
		}
		if (this.extraData.leadRequestSourcePage) {
			this.__contactSourceExtraInfoLabel += " (" + this.extraData.leadRequestTrafficType.replace(/"/g, "'") + ")";
		}
	}

	parseNotInterested() {
		if (this.activityStatus === 9) {
			this.__notInterestedForCSVExport = "X";

			if (this.extraData.leadNotInterestedReason) {
				this.__notInterestedForCSVExport += ` (${this.extraData.leadNotInterestedReason})`;
			}
		}
		else {
			this.__notInterestedForCSVExport = "";
		}
	}

	parsePeople () {
		this.people = this.people.map(item => new Person(item));
		this.reindexPeople();

		this.__peopleCount = this.people.length + 1;
	}

	parseReferenceLine () {
		const referenceLabels = new Set();
		this.__referenceLineLabel = "";

		if (this.extraData.leadInterestSolutions.length > 0) {
			this.extraData.leadInterestSolutions.forEach(item => {
				switch (item) {
					case 1:
					case 2:
					case 3:
						referenceLabels.add("Pavimentazioni Indoor");
						break;
					case 4:
					case 5:
					case 6:
						referenceLabels.add("Pavimentazioni Outdoor");
						break;
					case 7:
						referenceLabels.add("Divisione Marine");
						break;
				}
			}, this);

			this.__referenceLineLabel = Array.from(referenceLabels).join(", ");
		}
		else {
			this.__referenceLineLabel = "N/D";
		}

		// document.querySelectorAll(`.referenceLineOptionsBoxes`).forEach(item => item.classList.add("d-none"));
		// const referenceLineOptionsBox = document.querySelector(`#referenceLine${this.referenceLineId}OptionsBox`);

		// if (referenceLineOptionsBox) {
		// 	referenceLineOptionsBox.classList.remove("d-none");
		// }
	}

	promoteToClient () {
		if ([Client.STATUS_CONTACT_FROM_SIS, Client.STATUS_LEAD, Client.STATUS_PROSPECT, Client.STATUS_REPORT_FROM_LEAD].indexOf(this.status) > -1) {
			let newStatus;
			
			this.extraData.previousStatus = this.status;

			switch (this.status) {
				case Client.STATUS_CONTACT_FROM_SIS:
					newStatus = Client.STATUS_CLIENT_FROM_SIS_CONTACT;
					break;
				case Client.STATUS_LEAD:
				case Client.STATUS_REPORT_FROM_LEAD:
					newStatus = Client.STATUS_CLIENT_FROM_LEAD;
					break;
				case Client.STATUS_PROSPECT:
					newStatus = Client.STATUS_CLIENT_FROM_PROSPECT;
					break;
			}
			this.status = newStatus;
			return true;
		}
		else {
			return false;
		}
	}

	reindexPeople () {
		this.people.forEach((item, index) => item.__index = index);
	}

	removePerson (index) {
		this.people.splice(index, 1);
		this.reindexPeople();
		this.emit("peopleChanged");
	}

	validate (type) {
		const errors = [];
		this.__errors = {};
		this.__errorsCount = 0;

		if (this.contactSource === "0") {
			errors.push("Devi indicare la sorgente del contatto dell'azienda");
			this.__errors.contactSource = true;
			this.__errorsCount++;
		}
		if (this.extraData.isIndividual) {
			null;
		}
		else {
			if (this.name === "") {
				errors.push("Devi indicare il nome dell'azienda");
				this.__errors.name = true;
				this.__errorsCount++;
			}
		}
		//Dave.Warn: Va riattivato con però un permesso per singolo utente per poter omettere la provincia (server per i Lead assegnati ad Export)
		// if (this.province === "") {
		// 	errors.push("Devi indicare la provincia dell'azienda");
		// 	this.__errors.province = true;
		// 	this.__errorsCount++;
		// }

		if (type === "lead") {
			if (this.extraData.leadInterestSolutions.length === 0) {
				errors.push("È obbligatorio selezionare una soluzione di interesse.<br>Se non hai indicazioni precise puoi selezionare 'Richiesta generica'.");
				this.__errors.extraData_leadInterestSolutions = true;
				this.__errorsCount++;
			}
		}

		this.__lastValidationErrors = errors;
		this.__isValid = this.__errorsCount === 0;

		return errors;
	}
}

Shark.registerModel("Client", Client);

export default Client;